import React from "react";
import { Link } from "react-router-dom";
import { IAS_PEDAGOGY } from "../../app-constants";

import Logo2 from "../../assets/images/logos/logo2.png";

const Footer = (props) => {
  const { footerLogo, footerClass, ctaSubtitle, ctaTitle, ctaBtn } = props;

  return (
    <>
      <footer
        id="react-footer"
        className={
          footerClass ? footerClass : "react-footer react-footer-two pt---120"
        }
      >
        <div className="footer-top">
          <div
            className="footer-top-cta wow animate__fadeInUp"
            data-wow-duration="0.6s"
          >
            <div className="row">
              <div className="col-lg-7">
                <h4>
                  {ctaSubtitle
                    ? ctaSubtitle
                    : "Crack UPSC with the right guidance"}
                </h4>
                <h3>
                  {ctaTitle
                    ? ctaTitle
                    : `Limited seats available! Only ${IAS_PEDAGOGY.TOTAL_INTAKE} aspirants per batch.`}
                </h3>
              </div>
              <div className="col-lg-5 text-right">
                <Link
                  to={`https://wa.me/${
                    IAS_PEDAGOGY.WHATSAPP_CHAT
                  }?text=${encodeURIComponent(
                    IAS_PEDAGOGY.WHATSAPP_CHAT_MESSAGE
                  )}`}
                  target="_blank"
                >
                  {ctaBtn ? ctaBtn : "WhatsApp Us for Admission"}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    className="feather feather-arrow-right"
                  >
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                    <polyline points="12 5 19 12 12 19"></polyline>
                  </svg>
                </Link>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="row">
              <div className="col-lg-3 md-mb-30">
                <div className="footer-widget footer-widget-1">
                  <div className="footer-logo white">
                    <Link to="/" className="logo-text">
                      <img src={Logo2} alt="Best UPSC coaching in Bangalore" />
                    </Link>
                  </div>
                  <h5 className="footer-subtitle">
                    Get expert guidance, structured courses, and quality study
                    material to achieve your IAS dreams.
                  </h5>
                  <ul className="footer-address">
                    {" "}
                    <li>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        className="feather feather-phone"
                      >
                        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                      </svg>
                      <a href={`tel:${IAS_PEDAGOGY.OFFICE_PHONE}`}>
                        {IAS_PEDAGOGY.OFFICE_PHONE}{" "}
                      </a>
                    </li>
                    <li>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        className="feather feather-phone"
                      >
                        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                      </svg>

                      <a href={`tel:${IAS_PEDAGOGY.PHONE_CONTACT2}`}>
                        {IAS_PEDAGOGY.PHONE_CONTACT2}{" "}
                      </a>
                    </li>
                    <li>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        className="feather feather-mail"
                      >
                        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                        <polyline points="22,6 12,13 2,6"></polyline>
                      </svg>
                      <a href={`mailto:${IAS_PEDAGOGY.CONTACT_EMAIL}`}>
                        {IAS_PEDAGOGY.CONTACT_EMAIL}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-3 md-mb-30">
                <div className="footer-widget footer-widget-2">
                  <h3 className="footer-title">About Us</h3>
                  <div className="footer-menu">
                    <ul>
                      <li>
                        <Link to="/about">About</Link>
                      </li>
                      <li>
                        <Link to="/course">Courses</Link>
                      </li>
                      <li>
                        <Link to="/event">Events</Link>
                      </li>
                      {/* <li>
                        <Link to="#">Career</Link>
                      </li> */}
                      {/* <li>
                        <Link to="/profile">Become a Teacher</Link>
                      </li> */}
                      <li>
                        <Link to="/contact">Contact</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 md-mb-30">
                <div className="footer-widget footer-widget-3">
                  <h3 className="footer-title">Useful Links</h3>
                  <div className="footer-menu">
                    <ul>
                      <li>
                        <Link to="/upsc-resources">Browse Resources</Link>
                      </li>
                      <li>
                        <Link to="/question-papers">
                          Previous Years Question Papers
                        </Link>
                      </li>
                      <li>
                        <Link to="/current-affairs">Current Affairs</Link>
                      </li>
                      <li>
                        <Link to="/blog">News & Blog</Link>
                      </li>
                      <li>
                        <Link to="/legal-disclaimer">Terms & Policies</Link>
                      </li>
                      {/* <li>
                        <Link to="/faq">FAQ</Link>
                      </li> */}
                      {/* <li>
                        <Link to="#">Tutorials</Link>
                      </li> */}
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="footer-widget footer-widget-4">
                  <h3 className="footer-title">Stay Updated</h3>
                  <div className="footer3__form">
                    <p>
                      Stay updated with UPSC preparation tips, important
                      notifications, <br />
                      and exclusive insights from IAS Jnani.
                      <br />
                    </p>{" "}
                    <form action="#">
                      <input
                        type="email"
                        required
                        placeholder="Enter your email"
                      />
                      <button
                        className="footer3__form-1"
                        onClick={() =>
                          window.open(IAS_PEDAGOGY.WHATSAPP_CHANNEL, "_blank")
                        }
                      >
                        <i className="arrow_right"></i>
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="copyright">
          <div className="container">
            <div className="react-copy-left">
              © 2025 <Link to="/">IAS Jnani.</Link> All Rights Reserved
            </div>
            <div className="react-copy-right">
              <ul className="social-links">
                <li className="follow">Follow us</li>
                <li>
                  <a href={IAS_PEDAGOGY.INSTAGRAM} target="_blank">
                    <span
                      aria-hidden="true"
                      className="social_instagram"
                    ></span>
                  </a>
                </li>
                <li>
                  <a href={IAS_PEDAGOGY.YOUTUBE} target="_blank">
                    <span aria-hidden="true" className="social_youtube"></span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
